<style>
  .step-segment { height: 8px; border-radius: 4px; transition: background-color 0.3s ease; }
</style>

<div class="row justify-content-center">
  <div class="col-12 col-md-10 col-xxl-6">
    <div class="section-header mb-4">
      <div class="d-flex justify-content-center gap-2 text-center">
        <span class="material-symbols-outlined">auto_towing</span>
        <h1 class="h4">Solicita en línea tu <strong class="fw-semibold text-colonial">Asistencia Vial</strong></h1>
      </div>
    </div>
  </div>
</div>

<div class="row justify-content-center">
  <div class="col-12 col-md-10 col-xxl-6">
    <div class="card">
      <div class="card-header bg-white pt-3">
        <h4 class="fs-5 text-colonial mb-2">Completa la información</h4>
        <div class="d-flex gap-2 mb-3">
          @for (step of stepsArray; track step) {
            <div class="step-segment flex-fill"
                 [style.background-color]="activeStep >= step ? '#9a0513' : '#dee2e6'">
            </div>
          }
        </div>
        <p class="text-muted small mb-1">
          <span class="fw-semibold">Paso {{ activeStep }} de {{ totalSteps }}:</span> {{ stepTitle }}
        </p>
      </div>
      <div class="card-body">
        <form [formGroup]="craneForm">
          @if(steps['client'] && activeStep === steps['client']) {            
            <app-client-selector (selectedClient)="handleClientSelected($event)"></app-client-selector>
            <div class="d-flex justify-content-between mt-4">
              <button class="btn btn-outline-dark border" type="button" (click)="prevStep()">Regresar</button>
              <button class="btn btn-dark bg-colonial border" type="button" [style.opacity]="!isCurrentStepValid ? '0.65' : '1'" (click)="onNextPressed()">Siguiente</button>
            </div>
          }
          @else if(activeStep === steps['policy']) {
            @if(showPolicySelector) {
              <h4 class="fs-6 mb-3 d-flex gap-2 align-items-center">
                ¿Cuál póliza necesita asistencia vial?
              </h4>
              <app-policy-step
                (onPolicySelected)="onPolicySelected($event)"
                [idNumber]="client?.idnumber"
                [policyFilter]="PolicyTypes.Vehicle"
                [showBackButton]="false">
              </app-policy-step>
              <div class="d-flex justify-content-start mt-3">
                <button class="btn btn-outline-dark border" type="button" (click)="prevStep()">Regresar</button>
              </div>
            } @else {
              <h4 class="fs-6 mb-3 d-flex gap-2 align-items-center">
              Póliza que necesita asistencia vial
              </h4>
              <div class="form-group my-3">
                <label>No. de póliza</label>
                <input [mask]="policyMask" class="form-control" formControlName="policyNumber" sharedFormInput type="text" />
              </div>
              <div class="form-group my-3">
                <label>No. de cédula o pasaporte</label>
                <input class="form-control" formControlName="idNumber" sharedFormInput type="text" />
              </div>
              <div class="d-flex justify-content-between mt-4">
                <button class="btn btn-outline-dark border" type="button" (click)="prevStep()">Regresar</button>
                <button class="btn btn-dark bg-colonial border" type="button" [style.opacity]="!isCurrentStepValid ? '0.65' : '1'" (click)="onNextPressed()">Siguiente</button>
              </div>
            }
          }
          @else if(activeStep === steps['contact']) {
            <h4 class="fs-6 mb-3 d-flex gap-2 align-items-center">
              Persona de contacto para la asistencia vial
            </h4>
            <div class="form-group my-3">
              <label>Nombre completo</label>
              <input [patterns]="{ 'A': { pattern: namePattern } }" class="form-control"
                     formControlName="clientName" mask="A*" sharedFormInput type="text" />
            </div>
            <div class="d-grid d-md-flex my-3 w-100 gap-3">
              <div class="form-group w-100">
                <label>Correo electrónico</label>
                <input class="form-control" formControlName="email" sharedFormInput type="text" />
              </div>
              <div class="form-group w-100">
                <label>Teléfono</label>
                <input class="form-control" formControlName="phoneNumber" mask="(000)000-0000" sharedFormInput type="text" />
              </div>
            </div>
            <div class="mb-3 form-check form-switch">
              <input class="form-check-input" formControlName="isMailSent" id="isMailSent" role="switch" type="checkbox">
              <label class="form-check-label" for="isMailSent">Deseo recibir información vía el Correo electrónico</label>
            </div>
            <div class="d-flex justify-content-between mt-4">
              <button class="btn btn-outline-dark border" type="button" (click)="prevStep()">Regresar</button>
              <button class="btn btn-dark bg-colonial border" type="button" [style.opacity]="!isCurrentStepValid ? '0.65' : '1'" (click)="onNextPressed()">Siguiente</button>
            </div>
          }
          @else if(activeStep === steps['crane']) {
            <h4 class="fs-6 mb-3 d-flex gap-2 align-items-center">
              Indica la dirección donde necesitas la asistencia vial:
            </h4>
            <div class="d-grid d-md-flex my-3 w-100 gap-3">
              <div class="form-group w-100">
                <label>Provincia</label>
                <input class="form-control" formControlName="province" sharedFormInput type="text" autocomplete="off" />
              </div>
              <div class="form-group w-100">
                <label>Municipio</label>
                <input class="form-control" formControlName="municipality" sharedFormInput type="text" autocomplete="off" />
              </div>
            </div>
            <div class="form-group my-3">
              <label>Escriba y seleccione la dirección de asistencia</label>
              <app-location-picker
                (addressChanged)="onCraneAddressChanged($event)"
                (dragEnd)="onCraneDragEnd($event)"
                (placeSelected)="onCranePlaceSelected($event)"
                [center]="center"
                [hideMapUntilSelected]="true"
                [performReverseGeocodeOnDrag]="true"
                [placeholder]="'Seleccione una dirección'"
                [validateAddress]="true"
                [zoom]="zoom"
                mapId="assistance-location-map">
              </app-location-picker>
            </div>
            <div class="form-group my-3">
              <label>Indique un lugar o establecimiento cercano</label>
              <textarea class="form-control" formControlName="closeTo" sharedFormInput></textarea>
            </div>
            <div class="form-group my-3">
              <label>Agregar cualquier descripción adicional</label>
              <textarea class="form-control" formControlName="description" sharedFormInput></textarea>
            </div>
            <div class="d-flex justify-content-between mt-4">
              <button class="btn btn-outline-dark border" type="button" (click)="prevStep()">Regresar</button>
              <button class="btn btn-dark bg-colonial border btn-lg" type="button" [style.opacity]="craneForm.invalid ? '0.65' : '1'" (click)="onSubmitPressed()">
                Solicitar Asistencia Vial
              </button>
            </div>
          }
        </form>
      </div>
    </div>
  </div>
</div>

<ng-template #successModal let-modal>
  <div class="modal-header border-0 pb-2 align-items-start">
    <div class="d-flex gap-2 align-items-start">
      <h5 class="modal-title fw-semibold text-colonial lh-sm mb-0">
        ¡Su solicitud de Asistencia Vial ha sido creada con éxito!
      </h5>
    </div>
    <button (click)="modal.dismiss()" aria-label="Cerrar" class="btn-close flex-shrink-0 ms-2" type="button"></button>
  </div>

  <div class="modal-body pt-0">
    <p class="text-muted small mb-3">Su solicitud ha sido registrada. Un agente se comunicará con usted a la brevedad.</p>

    <div class="d-flex flex-column gap-2">

      <div class="border rounded-3 p-3">
        <p class="fw-semibold small mb-2">EN CASO DE UN ACCIDENTE, OBTENGA LA SIGUIENTE INFORMACIÓN:</p>
        <ol class="mb-0 small ps-3">
          <li>Nombre y dirección del propietario y del conductor del otro vehículo.</li>
          <li>Número de placa, compañía aseguradora y número de póliza de dicho vehículo.</li>
          <li>Nombre y dirección de todos los testigos.</li>
          <li>Nombre y dirección de todos los lesionados.</li>
        </ol>
      </div>

      <div class="border rounded-3 p-3">
        <p class="fw-bold small mb-0">NO ACEPTE RESPONSABILIDAD EN EL MOMENTO DEL ACCIDENTE. RESERVE SU DERECHO</p>
      </div>

      <div class="border rounded-3 p-3">
        <p class="small mb-1 d-flex align-items-center gap-2">
          <span class="material-symbols-outlined text-muted flex-shrink-0" style="font-size:16px">local_police</span>
          En caso de robo de su vehículo notifíquelo a la policía.
        </p>
        <p class="small mb-0 d-flex align-items-center gap-2">
          <span class="material-symbols-outlined text-muted flex-shrink-0" style="font-size:16px">phone</span>
          En todo caso comuníquese a La Colonial:
          <a class="fw-semibold text-colonial text-decoration-none" href="tel:8095088000">809-508-8000</a>
        </p>
      </div>

      <div class="border rounded-3 p-3">
        <p class="fw-semibold text-colonial small mb-2">Centro del Automovilista CAA</p>
        <p class="small mb-1 d-flex align-items-center gap-2">
          <span class="material-symbols-outlined text-muted flex-shrink-0" style="font-size:16px">location_on</span>
          Sto. Dgo. — <a class="text-decoration-none text-dark" href="tel:8095658222">809-565-8222</a>
        </p>
        <p class="small mb-0 d-flex align-items-center gap-2">
          <span class="material-symbols-outlined text-muted flex-shrink-0" style="font-size:16px">location_on</span>
          Stgo. — <a class="text-decoration-none text-dark" href="tel:8095836222">809-583-6222</a>
        </p>
      </div>
    </div>
  </div>

  <div class="modal-footer border-0">
    <button (click)="modal.close()" class="btn btn-dark bg-colonial w-100" type="button">
      Entendido
    </button>
  </div>
</ng-template>
